export default __webpack_public_path__ + "static/media/rabbitmq.a4c56401fb9d4e0230e9e7751ca20f9f.svg";